import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=dd9cf97c&scoped=true&"
import script from "./TinymceEditor.vue?vue&type=script&lang=ts&"
export * from "./TinymceEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9cf97c",
  null
  
)

export default component.exports